/** Matches API reaction `type` values. */
export enum ReactionKind {
  ThumbsUp = "thumbs-up",
  ThumbsDown = "thumbs-down",
}

export function reactionKindToSummaryKey(
  kind: ReactionKind,
): "thumbsUp" | "thumbsDown" {
  return kind === ReactionKind.ThumbsUp ? "thumbsUp" : "thumbsDown";
}
